import i18next from 'i18next'
import { initReactI18next } from 'react-i18next'

const zhCN = {
  brand: { name: 'licensor', tagline: '授权管理，本该简单', taglineSub: '让软件授权对每个人都触手可及。', copyright: '版权所有 © 2021-2026 Licensor' },
  nav: { products: '产品', orders: '订单', licenses: '授权', profile: '我的', signOut: '退出登录', myAccount: '我的账户' },
  crumb: { portal: '我的账户' },
  auth: {
    login: '登录', register: '注册', createAccount: '创建账号', forgot: '忘记密码', reset: '设置新密码',
    email: '邮箱', password: '密码', newPassword: '新密码', confirmPassword: '确认新密码', name: '昵称',
    submit: '登录', submitRegister: '创建账号', submitForgot: '发送重置链接', submitReset: '确认修改',
    forgotLink: '忘记密码？', registerHint: '还没有账号？', loginHint: '已有账号？',
    resendHint: '链接已过期？', resendLink: '重新申请', backToLogin: '返回登录',
    registerTagline: '从一个版本开始', registerSub: '一个账号管理订单、授权与密钥。',
    forgotTagline: '一步找回访问权限', forgotSub: '我们会发送一封含一次性链接的重置邮件。',
    resetTagline: '设置新密码', resetSub: '该链接仅可使用一次。',
    verifyNote: '注册后我们会向你的邮箱发送验证邮件，验证后即可正常购买。',
    verifyTitle: '邮箱验证', verifying: '正在验证，请稍候…',
    verifySuccess: '邮箱验证成功，请登录。',
    verifyFailed: '验证失败：链接无效或已过期，请重新注册或联系支持。',
    verifyMissingToken: '链接缺少验证参数，请使用邮件里的完整链接。',
    verifyRequired: '邮箱尚未验证：请先完成邮箱验证再登录。',
    loginFailed: '登录失败，请稍后重试或联系支持。',
    forgotNote: '出于安全考虑，无论账号是否存在，我们都会发送一封含一次性链接的邮件。',
    resetNote: '密码至少 12 位，建议混合字母、数字与符号。',
    sentTitle: '邮件已发送', sentBody: '重置链接含一次性 token，有效期结束后需重新申请。',
  },
  products: {
    title: 'Licensor 产品', contact: '联系我们', myLicenses: '我的授权', buy: '购买',
    applyTrial: '申请试用', buyTrial: '{{price}} 试用', trialTag: '可试用 {{days}} 天', unbound: '未绑定',
  },
  buyPage: {
    title: '购买 {{name}}', purchase: '立即购买', signIn: '登录后购买',
    notFoundHint: '该产品不存在或已下架。',
    licenseNote: '支付成功后授权自动发放，可在「我的授权」查看与绑定设备。',
    perYear: '每年', back: '返回产品列表',
  },
  orders: {
    title: 'Licensor 订单', refresh: '刷新', goProducts: '去购买', detail: '订单详情',
    back: '返回', viewLicenses: '查看授权', buyAgain: '重新购买',
    cancelOrder: '取消订单', confirmPaid: '我已完成支付',
    amount: '合计金额', subtotal: '小计', code: '订单号',
    created: '创建', paid: '支付', expired: '订单过期', closed: '关闭', timeoutClose: '超时关闭',
    waitingCallback: '渠道回调等待中', licenseBound: '授权码已自动生成并关联',
    colProduct: '产品 / 版本', colQuantity: '数量', colUnit: '计费单位', colPrice: '单价',
    payments: '支付记录', linkedLicense: '关联授权',
    discount: '优惠券优惠', payable: '折后应付',
    footer: '支付结果由 webhook 回写，列表每 3 秒轮询刷新；支付成功后自动生成授权码并绑定订单。',
    status: { 1: '已创建', 2: '待支付', 3: '已支付', 4: '订单已履约', 5: '支付失败', 6: '已超时关闭', 7: '已退款' },
    unit: { 30: '月', 365: '年' },
  },
  licenses: {
    title: 'Licensor 授权管理', buy: '购买授权', renew: '续费', unbind: '解绑设备',
    detail: '授权详情', colEdition: '版本', colState: '状态', colMachine: '绑定设备',
    colActivatedAt: '激活时间', colExpiredAt: '到期时间', colRemark: '备注', colAction: '操作',
    colLease: '租约', never: '—', manage: '管理', editRemark: '编辑备注', copyKey: '复制许可证密钥',
    state: { 1: '待激活', 2: '已激活', 3: '已绑定', 4: '已暂停', 5: '已吊销', 6: '已过期' },
    trial: '试用', remarkPh: '输入备注（最多 500 字符）',
    remarkSaved: '备注已保存', noMachine: '未绑定',
    keyHint: '请前往目标产品的授权页面（位于右上角），粘贴下方显示的许可证密钥完成激活。',
  },
  buy: {
    title: '购买授权', annual: '年付', monthly: '月付', trial: '0 元试用',
    quantity: '数量', duration: '时长', year: '年', month: '月',
    edition: '版本', plan: '套餐', unitPrice: '单价', total: '合计',
    confirm: '确认支付', popular: '热门', trialNote: '0 元试用需提交申请，后台审批通过后发放，默认 {{days}} 天；每个账号每款产品仅可申请一次。',
    renewTitle: '续费', renewConfirm: '确认续费',
    trialTitle: '申请 0 元试用', trialDuration: '试用时长', trialRule: '到期规则',
    trialRuleValue: '审批通过日起算 {{days}} 天', applicant: '申请人', contactEmail: '联系邮箱',
    trialNoteField: '申请说明', trialNotePh: '简单说明试用用途，便于我们更快审批（选填）',
    trialFree: '¥ 0',
    trialNotice: '提交后进入后台审批，通常 1 个工作日内完成；通过后试用授权自动发放到「我的授权」，到期自动失效。',
    submitTrial: '提交申请',
    coupon: '优惠券', couponLink: '输入优惠券码', couponChange: '更换券码或移除',
    redeemTitle: '使用优惠券', redeemPh: 'AXIOM-8F3K-92QD', redeemQuery: '查询',
    redeemInvalid: '优惠券码无效或已过期，请检查后重试。',
    redeemTip: '券码由管理员在后台生成并发放；输入券码查询后可确认使用。',
    redeemCode: '券码', redeemScope: '适用范围', redeemValid: '有效期', redeemStatus: '状态',
    redeemStatusValue: '未使用 · 仅可使用一次',
    redeemOrderAmount: '当前订单', redeemPayable: '折后应付',
    redeemUsable: '券码有效，可用于当前订单；确认使用后将在支付成功时核销。',
    redeemHint: '同一订单仅可使用一张券；确认使用后在下单支付成功时核销，未支付则自动释放券码。',
    redeemNone: '不使用优惠券', redeemApply: '确认使用',
    freeDone: '订单已创建，授权已自动发放',
  },
  pay: {
    title: '收银台', payable: '应付金额',
    chooseTip: '选择支付方式完成「{{product}}」的购买',
    chooseHint: '支付完成后订单自动履约并发放授权码。',
    method: { wechat: '微信支付', alipay: '支付宝', creem: 'Creem 收银台' },
    scanWechat: '请使用微信扫一扫完成支付',
    scanOther: '请使用对应 App 扫一扫完成支付',
    openCashier: '无法扫码？在浏览器打开支付页面',
    hostedHint: '在 Creem 托管的收银台完成支付，支付成功后自动返回本页。',
    waiting: '等待支付结果…',
    backToChoose: '返回重新选择支付方式',
    success: '支付成功',
    successHint: '订单正在自动跳转，可前往订单详情查看。',
    closed: '订单未完成支付',
    closedHint: '订单已关闭或支付失败，可重新发起支付。',
    retry: '重新支付',
  },
  coupons: {
    scopeAll: '全部产品 · 全部版本', kindPercent: '折扣券', kindAmount: '优惠券',
    percentValue: '{{v}} 折', amountValue: '立减 {{v}}', amountThreshold: '满 {{m}} 减 {{v}}',
  },
  unbind: {
    title: '解绑设备', notice: '解绑会清空设备绑定并递增租约版本，该设备下次鉴权将直接失败。',
    desc: '设备需重新激活后才能继续使用；操作会写入授权历史与审计日志，不可撤销。',
    confirm: '确认解绑', cancel: '取消',
  },
  common: {
    cancel: '取消', save: '保存', confirm: '确认', close: '关闭', copy: '复制', copied: '已复制',
    total: '共 {{n}} 条', prev: '上一页', next: '下一页', loading: '加载中…',
    empty: '暂无数据', loadFailed: '加载失败', retry: '重试',
    year: '年', month: '月', day: '天', perPage: '每页', pageInfo: '第 {{p}} / {{t}} 页',
  },
  profile: {
    title: '我的', signOut: '退出登录', account: '账户信息', overview: '资产概览', security: '安全',
    email: '邮箱', status: '状态', createdAt: '注册时间', verified: '已验证', unverified: '未验证',
    recentOrders: '最近订单', recentLicenses: '最近授权', viewAll: '查看全部',
  },
}

const enUS = {
  brand: { name: 'licensor', tagline: 'Licensing, made simple', taglineSub: 'Software licensing within everyone\'s reach.', copyright: 'Copyright © 2021-2026 Licensor' },
  nav: { products: 'Products', orders: 'Orders', licenses: 'Licenses', profile: 'Profile', signOut: 'Sign out', myAccount: 'My Account' },
  crumb: { portal: 'My Account' },
  auth: {
    login: 'Sign in', register: 'Register', createAccount: 'Create account', forgot: 'Forgot password', reset: 'Set new password',
    email: 'Email', password: 'Password', newPassword: 'New password', confirmPassword: 'Confirm password', name: 'Name',
    submit: 'Sign in', submitRegister: 'Create account', submitForgot: 'Send reset link', submitReset: 'Confirm',
    forgotLink: 'Forgot password?', registerHint: 'No account yet?', loginHint: 'Already have an account?',
    resendHint: 'Link expired?', resendLink: 'Request again', backToLogin: 'Back to sign in',
    registerTagline: 'Start from one release', registerSub: 'One account for orders, licenses and keys.',
    forgotTagline: 'Recover access in one step', forgotSub: 'We will email you a one-time reset link.',
    resetTagline: 'Set new password', resetSub: 'This link can only be used once.',
    verifyNote: 'We will send a verification email after registration.',
    verifyTitle: 'Email verification', verifying: 'Verifying, please wait…',
    verifySuccess: 'Email verified. Please sign in.',
    verifyFailed: 'Verification failed: the link is invalid or expired.',
    verifyMissingToken: 'The link is missing its token; please use the full link from the email.',
    verifyRequired: 'Email not verified yet: please verify your email before signing in.',
    loginFailed: 'Sign-in failed. Please retry later or contact support.',
    forgotNote: 'For security reasons we send the same response whether the account exists or not.',
    resetNote: 'At least 12 characters; mix letters, digits and symbols.',
    sentTitle: 'Email sent', sentBody: 'The reset link carries a one-time token; request again after it expires.',
  },
  products: {
    title: 'Licensor Products', contact: 'Contact us', myLicenses: 'My licenses', buy: 'Buy',
    applyTrial: 'Apply for trial', buyTrial: 'Trial · {{price}}', trialTag: '{{days}}-day trial', unbound: 'Unbound',
  },
  buyPage: {
    title: 'Buy {{name}}', purchase: 'Purchase now', signIn: 'Sign in to purchase',
    notFoundHint: 'This product does not exist or is no longer available.',
    licenseNote: 'The license is issued automatically once the payment succeeds; find and bind it under My licenses.',
    perYear: 'per year', back: 'Back to products',
  },
  orders: {
    title: 'Licensor Orders', refresh: 'Refresh', goProducts: 'Buy', detail: 'Order detail',
    back: 'Back', viewLicenses: 'View licenses', buyAgain: 'Buy again',
    cancelOrder: 'Cancel order', confirmPaid: 'I have paid',
    amount: 'Total', subtotal: 'Subtotal', code: 'Order',
    created: 'Created', paid: 'Paid', expired: 'Expires', closed: 'Closed', timeoutClose: 'Timed out',
    waitingCallback: 'waiting for channel callback', licenseBound: 'license issued and linked',
    colProduct: 'Product / Edition', colQuantity: 'Qty', colUnit: 'Billing', colPrice: 'Unit price',
    payments: 'Payments', linkedLicense: 'Linked license',
    discount: 'Coupon discount', payable: 'Payable',
    footer: 'Payment status is written back by webhook; the list polls every 3 seconds.',
    status: { 1: 'Created', 2: 'Awaiting payment', 3: 'Paid', 4: 'Fulfilled', 5: 'Failed', 6: 'Expired', 7: 'Refunded' },
    unit: { 30: 'month', 365: 'year' },
  },
  licenses: {
    title: 'Licensor Licenses', buy: 'Buy license', renew: 'Renew', unbind: 'Unbind device',
    detail: 'License detail', colEdition: 'Edition', colState: 'State', colMachine: 'Machine',
    colActivatedAt: 'Activated', colExpiredAt: 'Expires', colRemark: 'Remark', colAction: 'Actions',
    colLease: 'Lease', never: '—', manage: 'Manage', editRemark: 'Edit remark', copyKey: 'Copy license key',
    state: { 1: 'Pending', 2: 'Active', 3: 'Bound', 4: 'Suspended', 5: 'Revoked', 6: 'Expired' },
    trial: 'Trial', remarkPh: 'Enter a remark (max 500 chars)',
    remarkSaved: 'Remark saved', noMachine: 'Unbound',
    keyHint: 'Open the target product\'s activation page (top right) and paste the license key below.',
  },
  buy: {
    title: 'Buy license', annual: 'Annual', monthly: 'Monthly', trial: 'Free trial',
    quantity: 'Quantity', duration: 'Duration', year: 'yr', month: 'mo',
    edition: 'Edition', plan: 'Plan', unitPrice: 'Unit price', total: 'Total',
    confirm: 'Confirm & pay', popular: 'Popular', trialNote: 'Trials require approval, granted in {{days}} days by default; one application per account per product.',
    renewTitle: 'Renew', renewConfirm: 'Confirm renewal',
    trialTitle: 'Apply for free trial', trialDuration: 'Trial length', trialRule: 'Expiry rule',
    trialRuleValue: '{{days}} days from approval', applicant: 'Applicant', contactEmail: 'Contact email',
    trialNoteField: 'Note', trialNotePh: 'Briefly describe your use case (optional)',
    trialFree: '$0',
    trialNotice: 'Your request goes to the approval queue, usually within one business day; the trial license lands in "My licenses" once approved.',
    submitTrial: 'Submit',
    coupon: 'Coupon', couponLink: 'Enter coupon code', couponChange: 'Change or remove code',
    redeemTitle: 'Use coupon', redeemPh: 'AXIOM-8F3K-92QD', redeemQuery: 'Query',
    redeemInvalid: 'The coupon code is invalid or expired; please check and retry.',
    redeemTip: 'Codes are issued by admins; enter a code, query it, then confirm to use it.',
    redeemCode: 'Code', redeemScope: 'Scope', redeemValid: 'Validity', redeemStatus: 'Status',
    redeemStatusValue: 'Unused · single use',
    redeemOrderAmount: 'Order', redeemPayable: 'Payable',
    redeemUsable: 'Code is valid for this order; it is redeemed when the payment succeeds.',
    redeemHint: 'One code per order; unredeemed codes are released automatically when the order is not paid.',
    redeemNone: 'No coupon', redeemApply: 'Confirm',
    freeDone: 'Order created; the license has been issued',
  },
  pay: {
    title: 'Checkout', payable: 'Amount due',
    chooseTip: 'Choose a payment method to complete "{{product}}"',
    chooseHint: 'The order is fulfilled and the license issued automatically once paid.',
    method: { wechat: 'WeChat Pay', alipay: 'Alipay', creem: 'Creem checkout' },
    scanWechat: 'Scan with WeChat to pay',
    scanOther: 'Scan with the matching app to pay',
    openCashier: 'Cannot scan? Open the payment page in your browser',
    hostedHint: 'Finish the payment on the Creem-hosted page; you will return here automatically.',
    waiting: 'Waiting for the payment result…',
    backToChoose: 'Back and pick another method',
    success: 'Payment successful',
    successHint: 'Redirecting automatically; the order detail page is also available.',
    closed: 'Order not paid',
    closedHint: 'The order was closed or the payment failed; you can pay again.',
    retry: 'Pay again',
  },
  coupons: {
    scopeAll: 'All products · All editions', kindPercent: 'Discount', kindAmount: 'Voucher',
    percentValue: '{{v}}% off', amountValue: '{{v}} off', amountThreshold: 'Spend {{m}}, save {{v}}',
  },
  unbind: {
    title: 'Unbind device', notice: 'Unbinding clears the device binding and bumps the lease version; the next auth from that device will fail.',
    desc: 'The device must be re-activated afterwards; the action is written to license history and audit log and cannot be undone.',
    confirm: 'Unbind', cancel: 'Cancel',
  },
  common: {
    cancel: 'Cancel', save: 'Save', confirm: 'Confirm', close: 'Close', copy: 'Copy', copied: 'Copied',
    total: '{{n}} items', prev: 'Prev', next: 'Next', loading: 'Loading…',
    empty: 'No data', loadFailed: 'Failed to load', retry: 'Retry',
    year: 'y', month: 'mo', day: 'd', perPage: 'Per page', pageInfo: 'Page {{p}} / {{t}}',
  },
  profile: {
    title: 'Profile', signOut: 'Sign out', account: 'Account', overview: 'Overview', security: 'Security',
    email: 'Email', status: 'Status', createdAt: 'Joined', verified: 'Verified', unverified: 'Unverified',
    recentOrders: 'Recent orders', recentLicenses: 'Recent licenses', viewAll: 'View all',
  },
}

// 部署区域决定默认语言：国内版 zh-CN、海外版 en-US（构建期 VITE_DEFAULT_LOCALE
// 注入，默认 zh-CN）；localStorage 已选语言优先，便于 e2e 与用户覆盖。
const defaultLocale = import.meta.env.VITE_DEFAULT_LOCALE || 'zh-CN'

export const i18n = i18next.createInstance()

void i18n.use(initReactI18next).init({
  resources: {
    'zh-CN': { translation: zhCN },
    'en-US': { translation: enUS },
  },
  lng: localStorage.getItem('licensor-locale') || defaultLocale,
  fallbackLng: 'en-US',
  interpolation: { escapeValue: false },
  returnNull: false,
})
